import { postOrThrow } from '../utils/ApiUtil';
import { getMock } from '../utils/mockRegistry';
import { mock } from '../common/mockFlag';
import type { HomeData } from './model';

export const HomeApi = {
  async getHomeData(): Promise<HomeData> {
    if (mock && false) {
      return getMock('homeData') as HomeData;
    }
    return postOrThrow<string, HomeData>('/sparrowWork/getHomeData', '');
  },
};
